var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',_vm._l((_vm.lines),function(item,index){return _c('b-skeleton',{key:("loader-line-" + index),attrs:{"animation":"fade","width":_vm.randomPercentage()}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }